import { Spin } from "antd";
import styled from "styled-components";

const SpinnClass = styled.div`
{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.4);
//   z-index: 1000;
}
`;

export default (props:any) => {
    if (!props.spinning) return null; // Evita renderizar el contenedor cuando spinning es falso
        
    return (
        <SpinnClass>
            <Spin tip="Espere" size="large" />
        </SpinnClass>
    );
}